// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// apiRefs — function references for the Convex experiment (#191).
//
// The Convex function code lives in the ROOT `convex/` dir (OUTSIDE src/) so
// Create React App never treats it as a TypeScript project (which would force a
// `typescript` dependency and break `npm start`/`npm run build` even in the
// default mongo mode). CRA's ModuleScopePlugin also forbids importing the
// generated `convex/_generated/api` from inside src/. So instead of importing
// the generated api, we build references by NAME with makeFunctionReference —
// fully equivalent for useQuery / ConvexHttpClient.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

import { makeFunctionReference } from "convex/server";

export const refs = {
  getUniqueLocations: makeFunctionReference("offices:getUniqueLocations"),
  getOfficeMetaDataByLocation: makeFunctionReference(
    "offices:getOfficeMetaDataByLocation"
  ),
  getUsers: makeFunctionReference("users:getUsers"),
  getProjectsByCompany: makeFunctionReference("activeQueue:getProjectsByCompany"),
  getProjectsByCompanyWithShared: makeFunctionReference(
    "activeQueue:getProjectsByCompanyWithShared"
  ),
  getCandidatesByCompany: makeFunctionReference(
    "candidates:getCandidatesByCompany"
  ),
  getAttributesByLocation: makeFunctionReference(
    "attributes:getAttributesByLocation"
  ),
  getStoresByLocation: makeFunctionReference("stores:getStoresByLocation"),
  getLaborCatalog: makeFunctionReference("laborCatalog:getLaborCatalog"),
  getProjectById: makeFunctionReference("activeQueue:getProjectById"),
  getProjectsByPayrollNoList: makeFunctionReference("activeQueue:getProjectsByPayrollNoList"),
  getCandidatesByPayrollNoList: makeFunctionReference("candidates:getCandidatesByPayrollNoList"),
  getUserByEmail: makeFunctionReference("users:getUserByEmail"),
  getUserById: makeFunctionReference("users:getUserById"),
  getSyncMeta: makeFunctionReference("sync:getSyncMeta"),
  // Compass data browser (#191) — read-only generic browse surface
  compassMirroredTables: makeFunctionReference("compass:mirroredTables"),
  compassSearchableFields: makeFunctionReference("compass:searchableFields"),
  compassGetByMongoId: makeFunctionReference("compass:getByMongoId"),
  compassGetManyByMongoId: makeFunctionReference("compass:getManyByMongoId"),
  compassBrowse: makeFunctionReference("compass:browse"),
  compassStats: makeFunctionReference("sync:stats"),
  // mutations (write-path dual-run)
  setScheduleById: makeFunctionReference("activeQueue:setScheduleById"),
  setSuppressionById: makeFunctionReference("activeQueue:setSuppressionById"),
  setAttributeById: makeFunctionReference("attributes:setAttributeById"),
  createNewAttribute: makeFunctionReference("attributes:createNewAttribute"),
  setUserById: makeFunctionReference("users:setUserById"),
  createNewUser: makeFunctionReference("users:createNewUser"),
  createLogEntry: makeFunctionReference("sync:createLogEntry"),
  // parity comparison log
  recordComparison: makeFunctionReference("comparisons:recordComparison"),
  // Time Machine (#114/#191) — point-in-time reconstruction + EventLog history.
  // These ALWAYS read PROD inside Convex (source hardcoded to "prod", #121).
  getStateAtTimestamp: makeFunctionReference("timeMachine:getStateAtTimestamp"),
  getStateAndEventsForDate: makeFunctionReference("timeMachine:getStateAndEventsForDate"),
  getEventLogByDocumentId: makeFunctionReference("timeMachine:getEventLogByDocumentId"),
  getEventLogForCrew: makeFunctionReference("timeMachine:getEventLogForCrew"),
  getEventLogForAttributeCell: makeFunctionReference("timeMachine:getEventLogForAttributeCell"),
};
